// PageDashboard Component

/* eslint react/jsx-indent: 0,
  react/jsx-curly-newline: 0,
  indent: 0,
  react/jsx-closing-bracket-location: 0,
  react/jsx-handler-names: 0 */

import React from 'react'
import $ from 'jquery'
import _ from 'lodash'
import classnames from 'classnames'

import IntlMessage from '../../common/intl/intl_message.jsx'
import app from '../../../app.jsx'
import Grid from '../../../common/common/grid/grid.jsx'
import PageBase from '../../../common/page/page_base/page_base.jsx'
import DashboardColumn from '../../dashboard/dashboard_column/dashboard_column.jsx'
import DashboardProjectItem from '../../dashboard/dashboard_projectitem/dashboard_projectitem.jsx'
import DashboardInvoiceItem from '../../dashboard/dashboard_invoiceitem/dashboard_invoiceitem.jsx'
import DashboardTimeGraph from '../../dashboard/dashboard_timegraph/dashboard_timegraph.jsx'
import DashboardTaskList from '../../dashboard/dashboard_tasklist/dashboard_tasklist.jsx'
import DashboardContentMessage from '../../dashboard/dashboard_contentmessage/dashboard_contentmessage.jsx'
import DialogConfirm from '../../../theme/dialog/dialog_confirm/dialog_confirm.jsx'
import Util from '../../../lib/util.jsx'
import DialogTaskDetail from '../../../task/dialog/dialog_taskdetail/dialog_taskdetail.jsx'
import TaskUtil from '../../../lib/taskutil.jsx'
import TimeUtil from '../../../lib/timeutil.jsx'
import DialogTimeCardDetail from '../../../time/dialog/dialog_timecard_detail/dialog_timecard_detail.jsx'
import DialogTimeCardAdd from '../../../time/dialog/dialog_timecardadd/dialog_timecardadd.jsx'
import DialogSetting from '../../../contact/dialog/dialog_setting/dialog_setting.jsx'
import ConfirmDelete from '../../../common/common/confirm_delete/confirm_delete.jsx'
import Button from '../../../common/common/button/button.jsx'
import Acl from '../../../lib/acl.jsx'
import PopupEmailConfirmation from '../../popup/popup_email_confirmation/popup_email_confirmation.jsx'
import DialogEmailValidation from '../../dialog/dialog_email_validation/dialog_email_validation.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import ReactHorizontalScroll from '../../../lib/reacthorizontalscroll/scroll.jsx'
import DialogEmailResend from '../../../common/dialog/dialog_email_resend/dialog_email_resend.jsx'
import InvoiceMailUtil from '../../../lib/invoicemailutil.jsx'
import eventfilters from '../../../lib/eventfilters.jsx'
import timerStates from '../../../../shared/util/timer/timerStates.js'
import { buildTimerEvents } from '../../../../shared/util/timer/timerEvents.js'
import DashboardWrap from './dashboard_wrap'
import DashboardHeaderBackground from './dashboard_header_background'
import DashboardContent from './dashboard_content'
import { ProjectsIcon } from '../../../common/layout/menu_icons/projects.jsx'
import { TasksIcon } from '../../../common/layout/menu_icons/tasks.jsx'
import { InvoicesIcon } from '../../../common/layout/menu_icons/invoices.jsx'

class PageDashboard extends PageBase {
  constructor (props) {
    super(props, 'dashboard', 'dashboard', 'dashboard')

    this.state = {
      loading: true,
      dataDate: null,
      taskInfo: null
    }

    this.data = {
      loggedInId: app.loggedInId,
      projects: [],
      invoice: [],
      taskGroups: [],
      myTime: {},
      totalTime: {},
      stat: {},
      sort: 'title',
      sortAsc: true,
      timeProjects: [],
      users: [],
      activeTask: null,
      currUser: null,
      showEmailReminder: false,
      filterType: 'open',
      countLoaded: 0,
      canPaginate: true,
      pageNo: 1,
      countLoadedInvoice: 0,
      canPaginateInvoice: true,
      pageNoInvoice: 1,
      bPaginate: false,
      bPaginateInvoice: false,
      activeInvoicePersons: [],
      confirmTaskCallback: null
    }

    this.weekNo = DateUtil.getLocalWeekNo()
    this.showFabButton = !!Acl.isPlannerAllowed()
    this._resizeHandler = this._resize.bind(this)
    this._bTeamExpired = app.isTeamExpired()
    this._setFABButtonState(!this._bTeamExpired, false)
    this._references = {
      dialogTimeCardAdd: React.createRef(),
      dialogTimeCardDetail: React.createRef(),
      popupemailconfirmation: React.createRef(),
      dialogemailvalidation: React.createRef(),
      refdialogMail: React.createRef(),
      confirmDelete: React.createRef(),
      taskSettingDialog: React.createRef(),
      dialogTaskDetail: React.createRef(),
      dialogConfirm: React.createRef()
    }
  }

  componentDidMount () {
    if (
      this.props.showDemoRegister !== undefined &&
      this.props.showDemoRegister
    ) {
      this.ignoreAutoSearch = true

      if (this._basePageReferences.dialogTrail.current) {
        this._basePageReferences.dialogTrail.current.show()
      }
    }

    $(window).on('resize', this._resizeHandler)
    this._getData(false)
    this._updateColumnMaxHeight()
    this._initEvents()
  }

  componentWillUnmount () {
    this._releaseEvents()
    $(window).off('resize', this._resizeHandler)
  }

  componentDidUpdate () {
    this._updateColumnMaxHeight()
  }

  renderContent () {
    const myTime = this.data.myTime
    const totalTime = this.data.totalTime
    const stat = this.data.stat
    const taskTabs = [
      {
        ident: 'all',
        label: 'common.list.filterAll'
      },
      {
        ident: 'open',
        label: 'common.list.filterOpen'
      }
    ]

    const timer = this._getTimer()

    const hasOverdueInvoices = stat.totalOverDueInvoices > 0
    const isFullUser = Acl.isFullUser()
    const showOverdueInvoices = hasOverdueInvoices && isFullUser && !app.isQuickbookConnected()
    const isPlannerAllowed = Acl.isPlannerAllowed()

    const scrollClassName = classnames({
      disable: !isPlannerAllowed || !isFullUser
    })

    let bShowLoader = false
    if (
      this.data.projects &&
      this.data.projects.length < stat.totalActiveProjects
    ) {
      bShowLoader = true
    }

    let bShowLoaderInvoice = false
    if (
      this.data.invoice &&
      this.data.invoice.length < stat.totalOverDueInvoices
    ) {
      bShowLoaderInvoice = true
    }

    return (
      <ReactHorizontalScroll className={scrollClassName}>
        <DashboardWrap
        // Number(Boolean) -> true is equal to 1 and false equal to 0
          numberOfColumns={2 + isPlannerAllowed + showOverdueInvoices}
        >
          <DashboardHeaderBackground />
         <DashboardContent>
            <DashboardColumn
              title='common.dashboard.titleTime'
              info={this._getDayLabel()}
              size='small'
            >
              <DashboardTimeGraph
                type='thisweek'
                showAdd
                onAdd={this._onAdd.bind(this)}
                timeTotal={totalTime.currentWeek}
                timeTaken={myTime.currentWeek}
                showTimer
                showAddTimer
                timer={timer}
                onAddTimeCard={this._onAddTimeCard.bind(this)}
                onStartTimer={this._onStartGraphTimer.bind(this)}
                onPauseTimer={this._onPauseGraphTimer.bind(this)}
                onClickProgressCircle={this._onClickProgressCircle.bind(
                  this,
                  'thisweek'
                )}
                onStopTimer={this._onStopGraphTimer.bind(this)}
                stopAndCreateNewTimeCard={this._stopAndCreateNewTimeCard.bind(
                  this
                )}
              />
              <DashboardTimeGraph
                type='lastweek'
                showAdd={false}
                onClickProgressCircle={this._onClickProgressCircle.bind(
                  this,
                  'lastweek'
                )}
                timeTotal={totalTime.lastWeek}
                timeTaken={myTime.lastWeek}
              />
              <DashboardTimeGraph
                type='beforeweek'
                showAdd={false}
                onClickProgressCircle={this._onClickProgressCircle.bind(
                  this,
                  'beforeweek'
                )}
                timeTotal={totalTime.beforeWeek}
                timeTaken={myTime.beforeWeek}
              />
            </DashboardColumn>
            {isPlannerAllowed && (
              <DashboardColumn
                title='common.dashboard.titleTask'
                count={stat.totalTasks}
                info={
                  stat.totalTasks > 1
                    ? 'common.dashboard.taskInfo'
                    : stat.totalTasks === 1
                    ? 'common.dashboard.taskInfoOne'
                    : 'common.dashboard.noTaskInfo'
                }
                alt
                filterTabs={taskTabs}
                tabsActive={this.data.filterType}
                onFilterTabsAction={this._onChangeTaskFilterType.bind(this)}
              >
                {this._renderTaskList()}
              </DashboardColumn>
            )}
            <DashboardColumn
              title='common.dashboard.titleProject'
              count={stat.totalActiveProjects}
              alt={!isPlannerAllowed}
              info={
                stat.totalActiveProjects > 1
                  ? 'common.dashboard.projectInfo'
                  : stat.totalActiveProjects === 1
                  ? 'common.dashboard.projectInfoOne'
                  : 'common.dashboard.noProjectInfo'
              }
            >
              {this._renderProjectItems()}
              <Grid
                objectList={this.data.projects}
                showLoader={bShowLoader}
                ignoreLoader
                onPaginate={this._onPaginate.bind(this)}
                onRenderGrid={this._onRenderGrid.bind(this)}
              />
            </DashboardColumn>
            {showOverdueInvoices && (
              <DashboardColumn
                title='common.dashboard.titleInvoice'
                total={stat.totalActiveInvoices}
                count={stat.totalOverDueInvoices}
                info={
                  stat.totalActiveInvoices > 0
                    ? 'common.dashboard.invoiceInfo'
                    : 'common.dashboard.noInvoiceInfo'
                }
                alt={isPlannerAllowed}
              >
                {this._renderInvoiceItems()}
                <Grid
                  objectList={this.data.invoice}
                  showLoader={bShowLoaderInvoice}
                  ignoreLoader
                  onPaginate={this._onPaginateInvoice.bind(this)}
                  onRenderGrid={this._onRenderInvoiceGrid.bind(this)}
                />
              </DashboardColumn>
            )}
            <DialogTaskDetail
              ref={this._references.dialogTaskDetail}
              onSubmit={this._onUpdateTaskDetail.bind(this)}
              onSearchActivity={this._onSearchActivity.bind(this)}
            />
            <DialogTimeCardDetail
              ref={this._references.dialogTimeCardDetail}
              projects={this.data.timeProjects}
              getActivities={TimeUtil.onSearchActivity}
              getTasks={TimeUtil.onGetTasks}
              onUpdateDetail={this._onUpdateTimeCardDetail.bind(this, false)}
              onFinalize={this._onUpdateTimeCardDetail.bind(this, true)}
              onDelete={this._onDeleteTimeCardDetail.bind(this)}
            />
            <DialogTimeCardAdd
              ref={this._references.dialogTimeCardAdd}
              projects={this.data.timeProjects}
              onSubmit={this._onSubmitAddTimeCard.bind(this)}
              getTasks={TimeUtil.onGetTasks}
              onSearchActivity={TimeUtil.onSearchActivity}
              onConfirmOutsideDate={this._onConfirmOutsideDate}
            />
            {this._renderSettingsDialog()}
         </DashboardContent>
          <PopupEmailConfirmation
            ref={this._references.popupemailconfirmation}
            onClick={this._onClickEmailAlert.bind(this)}
          />
          <DialogEmailValidation
            ref={this._references.dialogemailvalidation}
            onSubmit={this._onSubmitEmailValidation.bind(this)}
          />
          <DialogEmailResend
            ref={this._references.refdialogMail}
            onSubmit={this._onSubmitMail.bind(this)}
            showWithoutContext={false}
            downloadBaseUrl={`/invoice/preview/${app.getTeamId()}/${
              app.loggedInId
            }/`}
            showLanguage={app.teamCountry === 'NL' || app.teamCountry === 'DE'}
          />
          <DialogConfirm
            ref={this._references.dialogConfirm}
            title='time.dialog.dialogTitle'
            message='time.dialog.dialogTitle'
            labelOk='common.common.confirmYesButton'
            labelCancel='common.common.confirmNoButton'
            showOk
            showCancel
            onClickOk={this._onConfirmOk}
            onClickNo={this._onConfirmCancel}
          />
        </DashboardWrap>
      </ReactHorizontalScroll>
    )
  }

  getContentClassname () {
    return 'full'
  }

  /* Event handlers */
  _onAdd (ev) {
    ev.preventDefault()
  }

  _onRenderGrid (project) {
    const useProjectNumber = app.projectSetting.useProjectNo

    return (
      <DashboardProjectItem
        key={project.id}
        project={project}
        useProjectNumber={useProjectNumber}
        onClick={this._onProjectClick.bind(this)}
      />
    )
  }

  _onConfirmOk = () => {
    if (this.data.confirmTaskCallback) {
      this.data.confirmTaskCallback()
    }

    if (this._references.dialogConfirm.current) {
      this._references.dialogConfirm.current.hide()
    }
  }

  _onConfirmCancel = () => {
    this.data.confirmTaskCallback = null

    if (this._references.dialogConfirm.current) {
      this._references.dialogConfirm.current.hide()

      if (this._references.dialogTimeCardAdd.current) {
        this._references.dialogTimeCardAdd.current.hide()
      }
    }
  }

  _onConfirmOutsideDate = (message, callback) => {
    this.data.confirmTaskCallback = callback
    if (this._references.dialogConfirm.current) {
      this._references.dialogConfirm.current.showMessage(message)
    }
  }

  _onRenderInvoiceGrid (invoice) {
    const useProjectNumber = app.projectSetting.useProjectNo
    return (
      <DashboardInvoiceItem
        key={invoice.id}
        invoice={invoice}
        useProjectNumber={useProjectNumber}
        onView={this._onInvoiceClick.bind(this)}
        onResendMail={this._onResendMail.bind(this)}
        bShowReminder={Acl.isFullUser()}
      />
    )
  }

  _onAddProject (ev) {
    ev.preventDefault()

    app.changePage('project', 'showadd')
  }

  _onChangeTaskFilterType (type) {
    this.data.filterType = type
    this._reloadData()
  }

  _onProjectClick (project) {
    if (project && project.id) {
      app.setAsObject('project', project)
      setTimeout(() => {
        app.changePage(
          this._getUserFavoriteTab('projectView') || 'projectview-overview',
          project.id
        )
      }, 500)
    }
  }

  _onInvoiceClick (invoice) {
    if (invoice && invoice.id) {
      app.changePage('invoice-view', invoice.id)
    }
  }

  _onSubmitAddTimeCard (timeCard, bOpen) {
    this._isTimecardExistForActivity(timeCard, bExists => {
      if (!bExists) {
        this._onCreateTimeCard(timeCard, false, _res => {
          if (this._references.dialogTimeCardAdd.current) {
            this._references.dialogTimeCardAdd.current.hide()
            if (bOpen) {
              this.data.confirmTaskCallback = null
              this._references.dialogTimeCardAdd.current.show()
            }
          }
        })
      } else {
        if (this._references.dialogTimeCardAdd.current) {
          this._references.dialogTimeCardAdd.current.hide()
          if (bOpen) {
            this.data.confirmTaskCallback = null
            this._references.dialogTimeCardAdd.current.show()
          }
        }
      }
    })
  }

  _isTimecardExistForActivity (timeCard, callback) {
    if (timeCard.projectId && timeCard.activityId) {
      const date = new Date()
      const timeParams = {
        query: {
          projectId: timeCard.projectId,
          activityId: timeCard.activityId,
          userId: this.data.loggedInId,
          createdOn: {
            $gte: new Date(date.getFullYear(), date.getMonth(), date.getDate()),
            $lte: new Date(
              date.getFullYear(),
              date.getMonth(),
              date.getDate() + 1
            )
          }
        }
      }

      app
        .service('/api/timecard')
        .find(timeParams)
        .then(timecardRes => {
          callback(timecardRes.data.length > 0) // eslint-disable-line standard/no-callback-literal
        })
        .catch(err => {
          app.debug('### PageDashboard - _onSubmitAddTimeCard - Error', err)
        })
    } else {
      callback(false) // eslint-disable-line standard/no-callback-literal
    }
  }

  _onDeleteTimeCardDetail (timeCardId) {
    if (!timeCardId) {
      return false
    }

    // Remove timecard and remove timer
    this._removeTimerAndTimeCard(timeCardId, () => {
      if (this._references.dialogTimeCardDetail.current) {
        this._references.dialogTimeCardDetail.current.hide()
      }
    })
  }

  _onCreateTimeCard (timeCard, bStartTimer, callback) {
    if (timeCard) {
      timeCard.userId = this.data.loggedInId
      timeCard.createdOn = new Date()

      TimeUtil.createTimeCard(timeCard, createRes => {
        this.data.editTimeCardId = createRes.id

        if (bStartTimer) {
          this._onTimerStart(timeCard)
        }

        if (callback) {
          callback(createRes)
        }
      })
    }
  }

  _onTimerStart (timeCard) {
    // If current task paused update, else create it
    const timer = this._getTimer()
    const timerEvents = buildTimerEvents(app)
    if (timer.doesRelateToTimeCardId(timeCard.id)) {
      timer.resume(app)
    } else {
      timerEvents.createTimerFromTimeCard(app, timeCard)
    }
  }

  _onUpdateTimeCardDetail (bFinalize, timeCardId, detailObj, bStopTimer) {
    if (this._references.dialogTimeCardDetail.current) {
      this._references.dialogTimeCardDetail.current.hide()
    }

    const timer = this._getTimer()
    TimeUtil.updateTimeCardDetail(timeCardId, detailObj, timer, bStopTimer)

    // Complete task on finalize
    if (bFinalize && detailObj.taskId) {
      TimeUtil.onCompleteTask(detailObj.taskId)
    }
  }

  _onClickEmailAlert (_ev) {
    if (
      this._references.popupemailconfirmation.current &&
      this._references.dialogemailvalidation.current
    ) {
      this._references.popupemailconfirmation.current.hide()
      this._references.dialogemailvalidation.current.show(
        this.data.currUser ? this.data.currUser.email : ''
      )
    }
  }

  _onSubmitEmailValidation (email) {
    const confirmObj = {
      userId: this.data.loggedInId,
      email: email,
      teamId: app.getTeamId(),
      language: IntlUtil.getLang()
    }
    return app
      .service('/api/user/confirm')
      .create(confirmObj, {})
      .then(_res => {
        this._refresh()
        if (this._references.dialogemailvalidation.current) {
          this._references.dialogemailvalidation.current.hide()
        }
      })
      .catch(err => {
        app.debug('PageDashboard: _onSubmitEmailValidation err', err)
      })
  }

  _onChangeDate (value, callback) {
    if (value) {
      TaskUtil.getDateSchedule(app.loggedInId, value, callback)
    }
  }

  _onSubmitMail (mailObj) {
    app.debug('PageInvoice: _onSubmitMail [Start]')

    const emails = []
    const contactPersons = this.data.activeInvoicePersons
    if (contactPersons.length > 0) {
      contactPersons.map(contactPerson => {
        if (mailObj.toEmails && mailObj.toEmails.length > 0) {
          mailObj.toEmails.map(mail => {
            if (mail.text === contactPerson.key) {
              emails.push(contactPerson.email)
            }
          })
          _.remove(
            mailObj.toEmails,
            toEmail => toEmail.text === contactPerson.key
          )
        }
      })
    }

    mailObj.toEmails.map(mail => {
      emails.push(mail.text)
    })

    mailObj.toEmails = emails

    return InvoiceMailUtil.onSubmitMail(mailObj, res => {
      if (res) {
        this._updateInvoice(mailObj.id)
        if (this._references.refdialogMail.current) {
          this._references.refdialogMail.current.hide()
        }
        this._reloadData()
      } else {
        app.debug('PageInvoice : _onSubmitMail err')
      }
    })
  }

  _updateInvoice (invoiceId) {
    const updateObj = { lastReminderDate: DateUtil.getUTCCurrentDate() }

    app
      .service('/api/invoice')
      .patch(invoiceId, updateObj)
      .then(_updateRes => {
        this._reloadData()
      })
      .catch(introErr => {
        app.debug('PageInvoice: _onUpdateInvoice err', introErr)
      })
  }

  /* Private functions */
  _renderSettingsDialog () {
    const { taskInfo, loading } = this.state
    if (loading) {
      return ''
    }

    let task = null
    let bDisable = false
    let tooltipDelete = null
    let tooltipEdit = null

    if (taskInfo) {
      task = taskInfo.task
      bDisable = !taskInfo.canEdit

      if (taskInfo.isPhaseClosed) {
        tooltipDelete = 'common.dashboard.tipDisableDeleteTextProjectClosed'
        tooltipEdit = 'common.dashboard.tipDisableEditTextProjectClosed'
      } else if (!taskInfo.canEdit) {
        tooltipDelete = 'common.dashboard.tipDisableDeleteText'
        tooltipEdit = 'common.dashboard.tipDisableEditText'
      }
    }

    const colClass = 'actionboard-col2 alert-col2'
    const _actionBtnClass = `action-btn${bDisable ? ' disable' : ''}`
    const _buttonDeleteClass = `button_dialog button_dialogdlt button_dialogdlt ${
      bDisable ? ' disabled' : ''
    }`
    const _buttonEditClass = `button_dialog button_dialogedit ${
      bDisable ? ' disabled' : ''
    }`

    return (
      <DialogSetting
        ref={this._references.taskSettingDialog}
        onClose={this._onCloseSetting.bind(this)}
      >
        <div className='actionboard-row act-row'>
          <div className={colClass}>
            <div
              className={_actionBtnClass}
              onClick={!bDisable ? this._onDelete.bind(this) : null}
            >
              <Button
                icon='action-delete'
                className={_buttonDeleteClass}
                canHover={false}
                tooltip={tooltipDelete}
                tooltipPosition='top'
              />
              <span className='label'>
                <IntlMessage ident='common.dashboard.actionDelete' />
              </span>
            </div>
          </div>
          <div className={colClass}>
            <div
              className={_actionBtnClass}
              onClick={!bDisable ? this._onEdit.bind(this, task) : null}
            >
              <Button
                icon='action-edit'
                className={_buttonEditClass}
                canHover={false}
                tooltip={tooltipEdit}
                tooltipPosition='top'
              />
              <span className='label'>
                <IntlMessage ident='common.dashboard.actionEdit' />
              </span>
            </div>
          </div>
        </div>
        {task && task.file && (
          <div className='actionboard-row act-row'>
            <div className='actionboard-col2 alert-col2'>
              <div className='action-btn'>
                <a
                  className='action-link'
                  href={encodeURI(
                    `/task/preview/${task.teamId}/${task.file.fileName}`
                  )}
                  rel='noopener noreferrer'
                  target='_blank'
                />
                <Button
                  icon='action-attachment'
                  className='button_dialog'
                  canHover={false}
                />
                <span className='label'>
                  <IntlMessage ident='task.list.actionOpenAttachment' />
                </span>
              </div>
            </div>
          </div>
        )}
        <ConfirmDelete
          ref={this._references.confirmDelete}
          title='common.dashboard.msgConfirmDelete'
          onClickOk={this._onClickDeleteConfirm.bind(this)}
        />
      </DialogSetting>
    )
  }

  _onCloseSetting () {
    if (this._references.confirmDelete.current) {
      this._references.confirmDelete.current.hide()
    }
  }

  _onEdit (task, e) {
    e.preventDefault()
    app.changePage('task', task.id, {
      date: task.nearestScheduleDate,
      project: null
    })
  }

  _onDelete (e) {
    e.preventDefault()
    if (this._references.confirmDelete.current) {
      this._references.confirmDelete.current.show()
    }
  }

  _onClickDeleteConfirm (e) {
    e.preventDefault()
    TaskUtil.removeTask(this.state.taskInfo.task.id, (deleteRes, deleteErr) => {
      if (!deleteErr) {
        if (this._references.taskSettingDialog.current) {
          this._references.taskSettingDialog.current.hide()
        }
        this.data.pageNo = 1
        this._reloadData()
      } else {
        app.debug('PageTime: _onClickDeleteConfirm Error', deleteErr)
      }
    })
  }

  _getDayLabel () {
    const day = new Date().getDay()

    if (day === 1) {
      return 'common.dashboard.infoMonday'
    } else if (day === 2) {
      return 'common.dashboard.infoTuesday'
    } else if (day === 3) {
      return 'common.dashboard.infoWednesday'
    } else if (day === 4) {
      return 'common.dashboard.infoThursday'
    } else if (day === 5) {
      return 'common.dashboard.infoFriday'
    } else if (day === 6) {
      return 'common.dashboard.infoSaturday'
    }

    return 'common.dashboard.infoSunday'
  }

  _onPaginate () {
    if (this.data.canPaginate) {
      if (this.data.bPaginate) {
        const page = this.data.pageNo + 1
        this.data.pageNo = page
        this._reloadProjectData()
      }
      this.data.bPaginate = true
    }
  }

  _onPaginateInvoice () {
    if (this.data.canPaginateInvoice) {
      if (this.data.bPaginateInvoice) {
        const page = this.data.pageNoInvoice + 1
        this.data.pageNoInvoice = page
        this._reloadInvoiceData()
      }
      this.data.bPaginateInvoice = true
    }
  }

  _reloadProjectData () {
    this._getDashboardData(true, result => {
      if (result) {
        this._onPageDataRecieved(result.pageData)
        if (result.dashboardResult) {
          this.data.projects =
            this.data.pageNo > 1
              ? this.data.projects.concat(result.dashboardResult.myProjects)
              : result.dashboardResult.myProjects
        }
        this.data.countLoaded = 15 * this.data.pageNo
        this.data.canPaginate = !(
          this.data.countLoaded > this.data.stat.totalActiveProjects
        )
        this._onDataReceived(null)
      }
    })
  }

  _reloadInvoiceData () {
    this._getDashboardData(true, result => {
      if (result) {
        this._onPageDataRecieved(result.pageData)
        if (result.dashboardResult) {
          this.data.invoice =
            this.data.pageNoInvoice > 1
              ? this.data.invoice.concat(result.dashboardResult.overdueInvoices)
              : result.dashboardResult.overdueInvoices
        }
        this.data.countLoadedInvoice = 15 * this.data.pageNoInvoice
        this.data.canPaginateInvoice = !(
          this.data.countLoadedInvoice > this.data.stat.totalOverDueInvoices
        )
        this._onDataReceived(null)
      }
    })
  }

  _onDialogClose () {
    if (!Acl.isStandardUser()) {
      this._setFABButtonVisible(true)
      this.setState({ dataDate: new Date() })
    }
  }

  _onCreateTask (task, bOpen, taskId, attachment, bFileDeleted) {
    if (taskId) {
      TaskUtil.updateTask(
        taskId,
        task,
        attachment,
        bFileDeleted,
        (updateRes, updateErr) => {
          if (!updateErr) {
            this.showFabButton = true

            this._reloadData()
          } else {
            app.debug('PageDashboard: updateTask Error', updateErr)
          }
        }
      )
    } else {
      TaskUtil.createTask(
        task,
        attachment,
        bFileDeleted,
        (createRes, createErr) => {
          if (!createErr) {
            this.showFabButton = true
          } else {
            app.debug('PageDashboard: createTask Error', createErr)
          }
        }
      )
    }
  }

  _onSearchActivity (projectId, callback) {
    const extraQuery = {}
    const project = _.find(this.data.projects, obj => obj.value === projectId)

    if (project && project.activePhaseNos) {
      extraQuery.activePhaseNos = project.activePhaseNos
    }

    TaskUtil.searchActivity(projectId, extraQuery, callback)
  }

  onAdd () {}

  _renderInvoiceItems () {
    if (this.state.loading) {
      return ''
    }

    if (this.data.invoice && this.data.invoice.length > 0) {
      return ''
    }

    return (
      <DashboardContentMessage
        icon={<InvoicesIcon width={75} />}
        info='common.dashboard.addInvoiceInfo'
      />
    )
  }

  _renderProjectItems () {
    const user = app.loggedInUserTeam
    if (this.state.loading) {
      return ''
    }

    if (this.data.projects && this.data.projects.length > 0) {
      return ''
    }

    return (
      <DashboardContentMessage
        icon={<ProjectsIcon width={75} />}
        showAdd={!!Acl.isFullUser()}
        showAddPrefix
        infoPrefix={
          user.roleType === 'Full user'
            ? 'common.dashboard.addProjectInfoTitle'
            : 'common.dashboard.addProjectAltInfoTitle'
        }
        info={
          user.roleType === 'Full user'
            ? 'common.dashboard.addProjectInfo'
            : 'common.dashboard.addProjectAltInfo'
        }
        onAdd={this._onAddProject.bind(this)}
      />
    )
  }

  _onResendMail (invoice) {
    const invoiceId = invoice.id
    const params = { query: { bResend: true } }
    app
      .service('/api/invoice/mail')
      .get(invoiceId, params)
      .then(result => {
        if (result) {
          this.data.activeInvoicePersons = result.contactPersons
          if (this._references.refdialogMail.current) {
            this._references.refdialogMail.current.show(
              result,
              invoiceId,
              invoice
            )
          }
        }
      })
      .catch(err => {
        app.debug('PageInvoice: _showEmailDialog err', err)
      })
  }

  _onClickDownload (invoice) {
    const teamId = app.getTeamId()
    if (invoice) {
      const createObj = {
        invoiceId: invoice.id
      }

      app
        .service('/api/invoice/pdf')
        .create(createObj, {})
        .then(pdfRes => {
          app.redirect(
            encodeURI(`/invoice/download/${teamId}/${pdfRes.pdfName}`)
          )
        })
        .catch(pdfErr => {
          app.debug('PageInvoice: _onClickDownload', pdfErr)
        })
    }
  }

  _onItemSettingClick (taskInfo) {
    if (taskInfo) {
      this.setState({ taskInfo: taskInfo })
      if (this._references.taskSettingDialog.current) {
        this._references.taskSettingDialog.current.show(
          taskInfo.task.title,
          null,
          null,
          null
        )
      }
    }
  }

  _onAddTaskTime (task) {
    if (task.userId) {
      const timeCard = TaskUtil.getTimecardDataFromTask(task)
      TimeUtil.createTimeCard(timeCard, createRes => {
        app.changePage('time', 'showTimeCard', createRes.id, {
          userId: createRes.userId,
          date: null
        })
      })
    }
  }

  _renderTaskList () {
    if (this.state.loading) {
      return ''
    }

    let totalTasks = 0
    this.data.taskGroups.map((taskgroup, _idx) => {
      if (taskgroup.tasks.length > 0) {
        totalTasks++
      }
    })

    const timer = this._getTimer()
    if (this.data.taskGroups && totalTasks > 0) {
      return (
        <DashboardTaskList
          taskGroups={this.data.taskGroups}
          timer={timer}
          loggedInUserId={this.data.loggedInId}
          stopAndCreateNewTimeCard={this._stopAndCreateNewTimeCard.bind(this)}
          onStart={this._onStart.bind(this)}
          onStop={this._onStop.bind(this)}
          onPause={this._onPause.bind(this)}
          onResume={this._onResume.bind(this)}
          onCompleteTask={this._onCompleteTask.bind(this)}
          onUpdateSubTasks={this._onUpdateSubTasks.bind(this)}
          sortOptions={this._getSortOptions()}
          sort={this.data.sort}
          sortAsc={this.data.sortAsc}
          onToggleExpandTask={this._onToggleExpandTask.bind(this)}
          onClickTaskSetting={this._onItemSettingClick.bind(this)}
          onAddTime={this._onAddTaskTime.bind(this)}
          onClickTask={this._onClickTask.bind(this)}
        />
      )
    }

    return (
      <DashboardContentMessage
        icon={<TasksIcon width={75} />}
        info='common.dashboard.addTaskInfo'
      />
    )
  }

  _refresh () {
    this.setState({ dataDate: new Date() })
  }

  _onClickTask (task) {
    app.changePage('task', task.id, {
      date: task.nearestScheduleDate,
      project: null
    })
  }

  _onStart (task) {
    const timer = this._getTimer()
    if (timer.exists && !timer.ProjectId()) {
      app
        .service('/api/timecard')
        .get(timer.TimeCardId(), {})
        .then(result => {
          if (result) {
            const timecard = result
            if (this._references.dialogTimeCardDetail.current) {
              this._references.dialogTimeCardDetail.current.show(
                timecard,
                true,
                false,
                !timer.TaskId()
              )
            }
            this.data.activeTask = task
          }
        })
        .catch(err => {
          app.debug('PageTime: _getDataTimeCardStat err', err)
        })
    } else {
      this._createOrUpdateTask(task)
    }
  }

  _createOrUpdateTask (task) {
    const timer = this._getTimer()
    const timerEvents = buildTimerEvents(app)
    if (timer.doesRelateToTaskId(task.id)) {
      timer.resume(app)
    } else {
      const createObj = {
        userId: this.data.loggedInId,
        projectId: task.projectId,
        activityId: task.activityId,
        taskId: task.id,
        timeCardId: null,
        status: timerStates.STARTED
      }

      timerEvents.createTimer(createObj)
    }
  }

  _onPause (_task) {
    const timer = this._getTimer()
    timer.pause(app)
  }

  _onResume (_task) {
    const timer = this._getTimer()
    timer.resume(app)
  }

  _onStop (_task) {
    const timer = this._getTimer()
    timer.stop(app)
  }

  _onCompleteTask (task, nonTrackedMinutes) {
    if (!task.id) {
      return
    }

    if (task.projectId && task.activityId) {
      app
        .service('/api/project/plannertask')
        .patch(task.id, { completed: task.completed }, {})
        .then(_result => {
          if (task.completed && task.userId) {
            this._createTimercardForCompletedTask(task, nonTrackedMinutes)
          } else {
            this.forceUpdate()
          }
        })
        .catch(err => {
          app.debug('PageDashboard: _onCompleteTask err', err)
        })
    } else {
      if (this._references.dialogTaskDetail.current) {
        this._references.dialogTaskDetail.current.show(
          task,
          nonTrackedMinutes,
          this.data.timeProjects
        )
      }
    }
  }

  _createTimercardForCompletedTask (task, nonTrackedMinutes) {
    const timeCard = TaskUtil.getTimecardDataFromTask(task)
    timeCard.timeTaken = nonTrackedMinutes
    if (nonTrackedMinutes <= 0) {
      TimeUtil.createTimeCard(timeCard, createRes => {
        app.changePage('time', 'showTimeCard', createRes.id, {
          userId: createRes.userId,
          date: null
        })
      })
    } else {
      TimeUtil.createTimeCard(timeCard, createRes => {
        app.changePage('time', 'showTimeCard', createRes.id, {
          userId: createRes.userId,
          date: null
        })
      })
    }
  }

  _onUpdateTaskDetail (task, nonTrackedMinutes) {
    if (!task.id) {
      return
    }

    const updateObj = {
      completed: task.completed,
      projectId: task.projectId,
      activityId: task.activityId
    }

    app
      .service('/api/project/plannertask')
      .patch(task.id, updateObj, {})
      .then(_result => {
        this._createTimercardForCompletedTask(task, nonTrackedMinutes)
      })
      .catch(err => {
        app.debug('PageDashboard: _onUpdateTaskDetail err', err)
      })
  }

  _onUpdateSubTasks (taskId, subtasks) {
    if (!taskId) {
      return
    }

    const updateObj = { subtasks: subtasks, noSubTasks: subtasks.length }
    app
      .service('/api/project/plannertask')
      .patch(taskId, updateObj, {})
      .then(_result => {
        this.forceUpdate()
      })
      .catch(err => {
        app.debug('PageDashboard: _onUpdateSubTasks err', err)
      })
  }

  _getData (bReload) {
    this._getDashboardData(bReload, result => {
      if (result) {
        this._onPageDataRecieved(result.pageData)
        if (result.dashboardResult) {
          this.data.projects =
            this.data.pageNo > 1
              ? this.data.projects.concat(result.dashboardResult.myProjects)
              : result.dashboardResult.myProjects
          this.data.invoice =
            this.data.pageNoInvoice > 1
              ? this.data.invoice.concat(result.dashboardResult.overdueInvoices)
              : result.dashboardResult.overdueInvoices
          this.data.taskGroups = result.dashboardResult.myTasks
          this.data.myTime = result.dashboardResult.myTime
          this.data.totalTime = result.dashboardResult.totalTime
          this.data.stat = result.dashboardResult.stat
        }

        if (result.projectOptions) {
          this.data.timeProjects = result.projectOptions
        }

        if (result.users) {
          this.data.users = result.users
        }

        if (result.currUser) {
          this.data.currUser = result.currUser
        }

        if (result.showEmailReminder) {
          this.data.showEmailReminder = result.showEmailReminder
        }

        if (this.props.showChangeTeam) {
          this._onShowSwitchAccount()
        }
        this.data.countLoaded = 15 * this.data.pageNo
        this.data.canPaginate = !(
          this.data.countLoaded > this.data.stat.totalActiveProjects
        )
        this.data.countLoadedInvoice = 15 * this.data.pageNoInvoice
        this.data.canPaginateInvoice = !(
          this.data.countLoadedInvoice > this.data.stat.totalOverDueInvoices
        )
        this.data.bPaginate = false
        this.data.bPaginateInvoice = false
        this._onDataReceived(null)
      }
    })
  }

  _getDashboardData (_bReload, callback) {
    const skip = (this.data.pageNo - 1) * 15
    const skipInvoice = (this.data.pageNoInvoice - 1) * 15
    const mondayDate = DateUtil.getMondayByDate(new Date())
    mondayDate.setHours(0, 0, 0, 0)
    const todayEndDate = new Date()
    todayEndDate.setHours(23, 59, 59, 0)

    const params = {
      query: {
        pageIdent: this._pageIdent,
        dashboard: {
          userId: this.data.loggedInId,
          weekNo: this.weekNo,
          weekStartDate: mondayDate,
          weekEndDate: DateUtil.addDaysToDate(mondayDate, 7),
          todayEndDate: todayEndDate,
          isRoleFinance: Acl.isRoleFinance(),
          clientTimezoneOffset: DateUtil.getLocalTimezoneOffset(),
          project: {
            $limit: 15,
            $skip: skip
          },
          invoice: {
            $limit: 15,
            $skip: skipInvoice
          }
        },
        userTeam: {
          teamId: app.getTeamId(),
          $select: ['userId', 'firstName', 'lastName'],
          status: 'active'
        }
      }
    }

    if (this.data.filterType === 'open') {
      params.query.dashboard.completed = false
    }

    app
      .service('/api/page/dashboard')
      .find(params)
      .then(result => {
        callback(result)
      })
      .catch(err => {
        if (this.props.showChangeTeam) {
          this._onShowSwitchAccount()
        }
        this._onDataReceived(err)
      })
  }

  _reloadData () {
    this._getData(true)
  }

  _getDataProject (callback) {
    const mondayDate = DateUtil.getMondayByDate(new Date())
    mondayDate.setHours(0, 0, 0, 0)
    const todayEndDate = new Date()
    todayEndDate.setHours(23, 59, 59, 0)

    const params = {
      query: {
        userId: this.data.loggedInId,
        weekStartDate: mondayDate,
        weekEndDate: DateUtil.addDaysToDate(mondayDate, 7),
        todayEndDate: todayEndDate,
        weekNo: this.weekNo
      }
    }

    if (this.data.filterType === 'open') {
      params.query.completed = false
    }

    params.query.isRoleFinance = Acl.isRoleFinance()

    app
      .service('/api/page/dashboard')
      .get(null, params)
      .then(result => {
        this.data.projects = result.myProjects
        this.data.invoice = result.overdueInvoices
        this.data.taskGroups = result.myTasks
        this.data.myTime = result.myTime
        this.data.totalTime = result.totalTime
        this.data.stat = result.stat
        callback(null)
      })
      .catch(err => {
        app.debug('PageDashboard: _getDataProject err', err)
        callback(err)
      })
  }

  _getDataTimeProjects (callback) {
    this._onTimeProjectSearch(null, true, null, options => {
      this.data.timeProjects = options
      callback(null)
    })
  }

  _getDataUsers (callback) {
    const userParams = {
      query: {
        teamId: app.getTeamId(),
        $select: ['userId', 'firstName', 'lastName']
      }
    }

    app
      .service('/api/users/team')
      .find(userParams)
      .then(userRes => {
        this.data.users = []
        if (userRes && userRes.total > 0) {
          userRes.data.map(user => {
            this.data.users.push({
              label: user.displayName,
              value: user.userId
            })
          })
        }
        callback(null)
      })
      .catch(userErr => {
        app.debug('PageDashboard: _getDataUsers Error', userErr)
        callback(userErr)
      })
  }

  _getLoggedInUser (callback) {
    app
      .service('/api/users')
      .get(app.loggedInId)
      .then(userRes => {
        this.data.currUser = userRes
        callback(null)
      })
      .catch(userErr => {
        app.debug('PageDashboard: _getLoggedInUser Error', userErr)
        callback(userErr)
      })
  }

  _getDataUserHistory (callback) {
    const userHistoryParams = {
      query: {
        userId: this.data.loggedInId
      }
    }

    app
      .service('/api/user/history')
      .find(userHistoryParams)
      .then(res => {
        if (res && res.total > 0) {
          this.data.showEmailReminder = res.data.length > 1
        }
        callback(null)
      })
      .catch(err => {
        app.debug('PageDashboard: _getDataUserHistory Error', err)
        callback(err)
      })
  }

  _onDataReceived (err) {
    if (err) {
      app.debug('PageDashboard: _onDataReceived Error', err)

      this._setFABButtonVisible(false)
      this.setState({ loading: true, dataDate: new Date() })
    } else {
      if (
        this._references.popupemailconfirmation.current &&
        this.data.showEmailReminder &&
        !this._bTeamExpired
      ) {
        this._references.popupemailconfirmation.current.show()
      }

      app.debug('PageDashboard: _onDataReceived [done]')

      if (!this.showFabButton) {
        this._setFABButtonVisible(false)
        this.showFabButton = true
      } else if (!Acl.isStandardUser()) {
        this._setFABButtonVisible(true)
      }

      this.setState({ loading: false, dataDate: new Date() })
    }
  }

  _resize () {
    window.setTimeout(this._updateColumnMaxHeight.bind(this), 500)
  }

  _updateColumnMaxHeight () {
    const cols = $('.dashboard-column > .colcontent')
    cols.css('height', 'auto')
    let maxHeight = 0

    for (let i = 1; i <= cols.length; i++) {
      const height = cols.eq(i - 1).outerHeight()
      if (height > maxHeight) {
        maxHeight = height
      }
    }

    if (maxHeight > 0) {
      const contOuterHeight = $('.dashboard-column .colheader')
        .eq(0)
        .outerHeight()
      const minHeight = $(window).outerHeight() - contOuterHeight

      if (maxHeight < minHeight) {
        maxHeight = minHeight
      }
      cols.css('height', `${maxHeight}px`)
    }
  }

  _updateTask (taskId, task) {
    if (!taskId) {
      return
    }

    const taskData = Util.removeObjectKeys(task, [
      'id',
      'user',
      'phase',
      'project',
      'activity',
      'expanded'
    ])
    app
      .service('/api/project/plannertask')
      .patch(taskId, taskData, {})
      .then(_result => {
        this.forceUpdate()
      })
      .catch(err => {
        app.debug('PageDashboard: _updateTask err', err)
      })
  }

  _getSortOptions () {
    return [
      { label: 'common.dashboard.orderByDateAsc', value: 'dateasc' },
      { label: 'common.dashboard.orderByDateDesc', value: 'datedesc' }
    ]
  }

  _onAddTimeCard () {
    app.changePage('time', 'addTimeCard')
  }

  _onClickProgressCircle (type) {
    const currentWeek = DateUtil.getLocalWeekNo()
    if (type === 'lastweek') {
      app.changePage('time', 'showWeek', currentWeek - 1)
    } else if (type === 'thisweek') {
      app.changePage('time', 'showWeek', currentWeek)
    } else {
      app.changePage('time', 'showWeek', currentWeek - 2)
    }
  }

  _onStartGraphTimer () {
    const timer = this._getTimer()
    if (timer.exists) {
      timer.resume(app)
    } else {
      const timeCard = {
        userId: this.data.loggedInId,
        projectId: null,
        activityId: null,
        taskId: null,
        activity: '',
        createdOn: new Date()
      }

      if (
        app.isDemo &&
        (timeCard.description === undefined || timeCard.description === '')
      ) {
        timeCard.description = Util.getRandomDescription()
      }

      app
        .service('/api/timecard')
        .create(timeCard)
        .then(createRes => {
          if (createRes) {
            this._onTimerStartFromTimeCard(createRes)
          }
        })
        .catch(createErr => {
          app.debug('PageDashboard: _onCreateTimeCard Error', createErr)
        })
    }
  }

  _onPauseGraphTimer () {
    const timer = this._getTimer()
    timer.pause(app)
  }

  _onTimerStartFromTimeCard (timeCard) {
    const timerEvents = buildTimerEvents(app)
    timerEvents.createTimerFromTimeCard(timeCard, this.data.loggedInId)
      .then(_userTaskRes => {})
      .catch(err => {
        app.debug('PageDashboard: _onTimerStartFromTimeCard Error', err)
      })
  }

  _onStopGraphTimer () {
    const timer = this._getTimer()
    if (timer.isAssignedToProjectActivity()) {
      timer.stop(app)
    } else {
      const timeCardObj = {
        id: timer.TimeCardId(),
        projectId: '',
        activityId: ''
      }

      // Pause the timer immediately once the stop button is pressed
      if (timer.isPauseable()) {
        timer.pause(app)
      }
      if (this._references.dialogTimeCardDetail.current) {
        this._references.dialogTimeCardDetail.current.show(
          timeCardObj,
          true,
          false,
          !timer.TaskId()
        )
      }
    }
  }

  /* Realtime Events */
  _initEvents () {
    this._initTimerEvents(this._onReloadTimer.bind(this))

    this._eventHandlers.taskCreated = this._eventReload.bind(
      this,
      'Task',
      'Created'
    )
    this._eventHandlers.taskUpdated = this._eventReload.bind(
      this,
      'Task',
      'Updated'
    )
    this._eventHandlers.taskRemoved = this._eventReload.bind(
      this,
      'Task',
      'Removed'
    )
    this._eventHandlers.taskPatched = this._eventReload.bind(
      this,
      'Task',
      'Patched'
    )

    const taskService = app.service('/api/project/plannertask')
    taskService.on('created', this._eventHandlers.taskCreated)
    taskService.on('updated', this._eventHandlers.taskUpdated)
    taskService.on('removed', this._eventHandlers.taskRemoved)
    taskService.on('patched', this._eventHandlers.taskPatched)

    this._eventHandlers.dataImported = this._onAfterDataImported.bind(this)
    app
      .service('/api/team/demo')
      .on('created', this._eventHandlers.dataImported)
  }

  _releaseEvents () {
    this._releaseTimerEvents()

    const taskService = app.service('/api/project/plannertask')
    taskService.off('created', this._eventHandlers.taskCreated)
    taskService.off('updated', this._eventHandlers.taskUpdated)
    taskService.off('removed', this._eventHandlers.taskRemoved)
    taskService.off('patched', this._eventHandlers.taskPatched)

    this._eventHandlers.taskCreated = null
    this._eventHandlers.taskUpdated = null
    this._eventHandlers.taskRemoved = null
    this._eventHandlers.taskPatched = null

    app
      .service('/api/team/demo')
      .off('created', this._eventHandlers.dataImported)
    this._eventHandlers.dataImported = null
  }

  _onAfterDataImported (eventData) {
    if (eventfilters.teamFilter(eventData)) {
      app.debug('-- Event - Pagedashboard - Import Done --')
      app.redirect('/')
    }
  }

  _onReloadTimer (eventData) {
    if (eventfilters.teamFilter(eventData)) {
      this._reloadData()

      if (this.data.activeTask) {
        this._createOrUpdateTask(this.data.activeTask)
        this.data.activeTask = null
      }
    }
  }

  _eventReload (objectName, eventName, eventData) {
    if (eventfilters.teamFilter(eventData)) {
      app.debug(`-- Event - Pagedashboard - ${objectName} - ${eventName} --`)
      this._reloadData()
    }
  }

  _onToggleExpandTask (_bExpand) {
    this._updateColumnMaxHeight()
  }
}

export default PageDashboard
